import { apiRequestWithChecks } from "./api";

export const pushNotificationApi = {
    getVapidKey(token) {
        return apiRequestWithChecks("GET", "/api/push-notification/vapid-key", {
            Authorization: "Bearer " + token
        });
    },

    saveSubscription(token, subscription) {
        const json = subscription.toJSON();
        return apiRequestWithChecks("POST", "/api/push-notification/subscribe", {
            Authorization: "Bearer " + token
        }, {
            endpoint: json.endpoint,
            p256dhKey: json.keys?.p256dh || '',
            authKey: json.keys?.auth || '',
            userAgent: navigator.userAgent
        });
    },

    deleteSubscription(token) {
        return apiRequestWithChecks("DELETE", "/api/push-notification/unsubscribe", {
            Authorization: "Bearer " + token
        });
    }
};
